import React from "react";
import api, { AppTreeDTO, AppUserMemory } from "api";
import { Icon } from "antd";


export interface AppTreeProps {
	scene: number;
	expandLevel?:number;
	onChange?: (data: AppTreeDTO) => void;
}

interface IAppTreeDTO extends AppTreeDTO{
	__tree_hidden?:boolean;
	__tree_blank_width?:number;
	__tree_expand_icon?:string;
	__table_checked?:boolean;
	__tree_indeterminate?:boolean;
}


export default class extends React.Component<AppTreeProps> {
	state = {
		data: [] as IAppTreeDTO[],
		value: {} as AppTreeDTO,
		userMemory: {} as AppUserMemory,
		selected: false,
		width: 0
	};

	refDiv = React.createRef<HTMLDivElement>();

	// 组织架构树形控件的数据类型为10000
	async componentDidMount() {
		let width = this.state.width;
		if(width !==0) return;

		let scene = this.props.scene;
		let data: IAppTreeDTO[] = await api.public.component.getAppTreeList({scene});
		data = this.toTreeData(data, 3);

		let userMemory = await api.public.component.getValue({scene});

		let value = {};
		if (userMemory.dataValue && userMemory.dataValue !== null ) {
			value = data.find(e => e.id === userMemory.dataValue);
			if (value) {
				this.props.onChange && this.props.onChange(value);
			} else {
				value = { name: "" };
			}
		}
		if(width===0 && this.refDiv && this.refDiv.current && this.refDiv.current.clientWidth ){
			 width = this.refDiv.current.offsetWidth 
		}

		 this.setState({ data, userMemory, value,width });
	}

	// 加工成控件需要的数据结构
	toTreeData = (treeData: any[], expandLevel: number) => {
		let miniLevel = treeData.length > 0 ? treeData[0].level : 1;
		expandLevel = expandLevel || 3;
		expandLevel = expandLevel + miniLevel - 1;
	
		treeData.forEach((item: any, index)=>{
			item.__table_index = index+1;
			item.__tree_hidden = item.level > expandLevel;
			item.__tree_blank_width =((item.isEnd === 1 ? 1 : 0) + item.level - miniLevel) * 15 + 5;
			item.__tree_expand_icon = item.level < expandLevel ? "caret-down" : "caret-right";
			item.__table_checked = false;
			item.__tree_indeterminate = false;
		});
		return treeData;
	};

	handleHidden = (display: boolean) => {
		this.setState({ selected:!display });
	};

	handleTextClick = () => {
		let { selected } = this.state;
		selected = !selected;
		this.setState({ selected });
	};

	handleSelectRow = async (newValue: IAppTreeDTO) => {
		if(!newValue.allowSelect) return;
		const { onChange } = this.props;
		let { userMemory, value } = this.state;

		if (newValue.id !== value.id) {
			onChange && onChange(newValue);
			this.setState({ value: newValue, userMemory, selected: false });
			userMemory = await api.public.component.setValue({
				...userMemory,
				dataValue: newValue.id,
				dataName:newValue.name
			});
			
		} else {
			this.setState({ selected: true });
		}
	};

	handleExpand = (rowData: IAppTreeDTO) => {
		let { data } = this.state;
		let ishow = rowData.__tree_expand_icon === "caret-right";
		let id = rowData.id;
		if (ishow) {
			for (let d of data) {
				if (d.parentId === id) d.__tree_hidden = false;
				if (d.id === id) d.__tree_expand_icon = "caret-down";
			}
		} else {
			let fullcode = rowData.fullCode + ".";
			for (let d of data) {
				if (d.fullCode.indexOf(fullcode) === 0) {
					d.__tree_hidden = true;
					d.__tree_expand_icon = "caret-right";
				}
				if (d.id === id) d.__tree_expand_icon = "caret-right";
			}
		}
		
		this.setState({ data });
	};


	// 组织树图标
	renderIcon = (rowData:IAppTreeDTO) =>{
		if(rowData.isEnd===1) return <React.Fragment/>
		return <div className='tree-icon' onClick={() => this.handleExpand(rowData)} style={{float:'left'}}  ><Icon  type={rowData.__tree_expand_icon}  /></div>
  	}

	// 加载组织树
	renderTr = (rowData:IAppTreeDTO) => {
		let isSelected = this.state.value.id && this.state.value.id===rowData.id ;
		// let dataIcon = "qcciconfont-organtree-jituan";
		// if(rowData.parentId !== 0){
		//   if(rowData.dataType==='xm') dataIcon = "qcciconfont-organtree-gongsi";
		// }
		return <tr className='tree-tr' data-selected={isSelected} hidden={rowData.__tree_hidden} key={rowData.id} >
				<td className="tree-td" >
					<div className="tree-td-blank" style={{width:rowData.__tree_blank_width}}></div>
					<div className="tree-data" title={rowData.name} >
					{this.renderIcon(rowData)}
					
					<div onClick={()=>this.handleSelectRow(rowData)}  style={{flex:1}}>
					<span style={{color:'#c3bbbb',padding:"0px 5px 0px 3px"}} className='qcciconfont-organtree-gongsi' hidden={rowData.dataType!=='xm'}></span>
					{rowData.name}
					</div>
					</div>
				</td>
		</tr>
	
	}

	renderTreeTable = () => {
		let { data, value } = this.state;
		return (
			<div className="app-tree-container">
				<table style={{ width: "100%" }} cellSpacing="0" cellPadding="0">
					<tbody>
						{data.map((rowData:IAppTreeDTO)=>{
							return this.renderTr(rowData);
						})}
					</tbody>
				</table>
			</div>
		);
	};

	render() {
		return (
			<div
				className="app-tree-select-container"
				tabIndex={-1}
				onBlur={() => this.handleHidden(true)}
			>
				<div
					className="app-tree-select-text"
					ref = {this.refDiv}
					onClick={() => this.handleTextClick()}
				>
					<span>{this.state.value.fullName}</span>
					<span className="app-tree-select-icon">
						<Icon type="down" />
					</span>
				</div>
				<div
					className="app-tree-select-content"
					hidden={!this.state.selected}
					style={{width:this.state.width }}
				>
					{this.renderTreeTable()}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/AppSelectTree/AppSelectTree.tsx